// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root___E-QQ","errors":"Errors_errors__2G0a1"};